const StringResult = (props: React.PropsWithChildren) => {
    if (props.children) return <>{props.children}</>;
    return <>N/A</>;
};

export default StringResult